import { pharmacyClient } from "@/connect";

export const getItemsReorder = async (page: number, pageSize: number) => {
  return await pharmacyClient.itemsToReorderReport({
    pageNumber: page,
    pageSize: pageSize,
  });
};